'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumberForm$() {
  this.aT7 = null;
  this.aTo = null;
  this.aTa = null;
  this.aTb = false;
  this.aTg = null;
  this.aTh = false;
  this.aTm = null;
  this.aTn = false;
  this.aT8 = null;
  this.aT9 = false;
  this.aTk = null;
  this.aTl = false;
  this.aTi = null;
  this.aTj = false;
  this.aTc = null;
  this.aTd = false;
  this.aTe = null;
  this.aTf = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumberForm$ = this;
  this.aT7 = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumber$();
  this.aTo = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($m_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumber$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumberForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumberForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumberForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumberForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumberForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumberForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumberForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumberForm$.prototype = $p;
$p.eR = (function() {
  return this.aT7;
});
$p.eO = (function() {
  return this.aTo;
});
$p.bW = (function() {
  if ((!this.aTb)) {
    this.aTa = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aTb = true;
  }
  return this.aTa;
});
$p.b9 = (function() {
  if ((!this.aTh)) {
    this.aTg = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aTh = true;
  }
  return this.aTg;
});
$p.b3 = (function() {
  if ((!this.aTn)) {
    this.aTm = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aTn = true;
  }
  return this.aTm;
});
$p.aG = (function() {
  if ((!this.aT9)) {
    this.aT8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aT9 = true;
  }
  return this.aT8;
});
$p.az = (function() {
  if ((!this.aTl)) {
    this.aTk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aTl = true;
  }
  return this.aTk;
});
$p.aY = (function() {
  if ((!this.aTj)) {
    this.aTi = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aTj = true;
  }
  return this.aTi;
});
$p.Jn = (function() {
  if ((!this.aTd)) {
    this.aTc = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Vessel/Flight Number";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aTd = true;
  }
  return this.aTc;
});
$p.bsp = (function() {
  if ((!this.aTf)) {
    this.aTe = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().jx;
    this.aTf = true;
  }
  return this.aTe;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumberForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumberForm$, "app.data.data_point_types$package$VesselOrFlightNumberForm$", ({
  GG: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumberForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumberForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumberForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumberForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumberForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumberForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumberForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumberForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumberForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumberForm$ };
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumber$() {
  this.aT5 = null;
  this.aT6 = false;
  this.aT3 = null;
  this.aT4 = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumber$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumber$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumber$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumber$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumber$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumber$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumber$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumber$.prototype = $p;
$p.aA = (function() {
  if ((!this.aT6)) {
    this.aT5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aT6 = true;
  }
  return this.aT5;
});
$p.bs7 = (function() {
  if ((!this.aT4)) {
    this.aT3 = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumberForm$().Jn();
    this.aT4 = true;
  }
  return this.aT3;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumber$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumber$, "app.data.data_point_types$package$VesselOrFlightNumber$", ({
  GF: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumber$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumber$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumber$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumber$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumber$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumber$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumber$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumber$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumber$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$VesselOrFlightNumber$ };
//# sourceMappingURL=app.data.data_point_types$package$-Vessel-Or-Flight-Number$.js.map
